import React, {useEffect, useState} from 'react'
import ExamImage from "../assets/images/exam.svg";
import {toPersianNumber,formatNumbers} from "../utils/numberConversion";
import {api} from "../utils/gashtaltAPI";
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";
import DownloadHandler from "../utils/downloadHandler";
import {useDisclosure} from "@chakra-ui/react";
import PayModal from "./PayModal";

const CountdownTimer = ({ endDate }) => {
    const calculateTimeLeft = () => {
        const difference = new Date(endDate) - new Date();
        let timeLeft = {};

        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60),
            };
        } else {
            timeLeft = { days: 0, hours: 0, minutes: 0, seconds: 0 };
        }

        return timeLeft;
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearInterval(timer); // Cleanup the interval on component unmount
    }, [endDate]);

    const formatTime = (value) => {
        return String(value).padStart(2, '0'); // Ensure 2 digits
    };

    return (
        <div className="date-counter">
            {/* Conditionally display days if greater than 0 */}
            {timeLeft.days > 0 && (
                <span>{formatTime(timeLeft.days)}:</span>
            )}
            <span>{formatTime(timeLeft.hours)}:</span>
            <span>{formatTime(timeLeft.minutes)}:</span>
            <span>{formatTime(timeLeft.seconds)}</span>
        </div>
    );
};

function ExamCard({id, name, Image,price, questionCount, time, authors, editor, startDate, endDate, hasPaid=false,past = false,answers_file,questions_file, onClick}) {
    const [started,setStarted] = useState(new Date(startDate) < new Date());
    const { isOpen, onOpen, onClose } = useDisclosure();
    const navigate = useNavigate();

    const startHandler = async (e) => {
        try {
            const response = await api.post(past ? '/api/exam/simulate' : '/api/exam/start', {
                exam_id: id
            })
            toast.success(response.data.message, {
                position: "bottom-right"
            });
            navigate('/ExamTaker')
        } catch (error) {
            if (error.response) {
                const status = error.response.status;
                if (status !== 500) {
                    toast.error(error.response.data.message, {
                        position: "bottom-right"
                    });
                }
                return;
            } else if (error.request) {
                toast.error("اتصال اینترنت خود را بررسی کنید!", {
                    position: "bottom-right"
                });
                return;
            }
            console.log(error)
            toast.error("خطایی رخ داد!", {
                position: "bottom-right"
            });
        }
    }

    return (<div className="col-lg-4 col-12 d-flex flex-column align-items-center">
        <div className="panel-exam-card d-flex flex-column align-items-center px-4" onClick={onClick}>
                <h5 className={'exam-card-title'}>{name}</h5>
            <img src={Image} className="card-img-top d-block mx-auto" alt="خطا" style={{paddingLeft:'1rem',paddingBottom:'.75rem',width:'65%',marginLeft:'1rem',marginRight:'1rem'}}/>
            {/*<div className={'row col-12 my-4 exam-info-block'}>
                <div className="col-lg-6 col-12">
                    <p className="col-12">
                        طراح :
                        <span>{" " + authors}</span>
                    </p>
                    <p className="col-12">
                        ویراستار :
                        <span>{" " + editor}</span>
                    </p>
                </div>
                <div className="col-lg-6 col-12">
                    <p className="col-12">
                        تعداد سوال :
                        <span>{" " + toPersianNumber(questionCount)}</span>
                    </p>
                    <p className="col-12">
                        زمان :
                        <span>{" " + toPersianNumber(time) + " دقیقه "}</span>

                    </p>
                </div>
                {!past && (<div className="col-12 mt-3 d-flex flex-row justify-content-around">
                    <p>
                        <span className='mx-1'>{!started ? 'زمان باقی مانده تا آغاز آزمون' : 'زمان باقی مانده تا پایان آزمون'}</span>
                    :
                    </p>
                    <CountdownTimer endDate={started ? endDate : startDate}/>
                </div>)}
            </div>*/}
            {!past && (<div className="col-12 mt-3 d-flex flex-row justify-content-around">
                <p>
                    <span className='mx-1'>{!started ? 'زمان باقی مانده تا آغاز آزمون' : 'زمان باقی مانده تا پایان آزمون'}</span>
                    :
                </p>
                <CountdownTimer endDate={started ? endDate : startDate}/>
            </div>)}
            <div className="d-flex flex-column justify-content-end flex-fill gap-2 col-11 pt-3">
                {past && hasPaid && (
                    <>

                        <button className="btn btn-outline-orange col-12" onClick={startHandler}>شرکت در آزمون
                        </button>
                        <div className="btn-group">
                            <button className="btn btn-outline-deep-blue col-5" onClick={() => {
                                DownloadHandler(questions_file)
                            }}>سوالات
                            </button>
                            {answers_file && (<button className="btn btn-outline-deep-blue col-5" onClick={() => {
                                DownloadHandler(answers_file)
                            }}>پاسخنامه
                            </button>)}
                        </div>
                        <button className="btn btn-outline-turquoise col-12  " onClick={() => {
                            navigate(`/videos/${id}`)
                        }} disabled={"true"}>
                            تحلیل ویدیویی
                        </button>
                    </>
                )}
                {past && !hasPaid && (
                    <button className="btn btn-outline-green col-12" onClick={onOpen}>
                        ثبت نام
                        (
                        {price === 0 ? 'رایگان' : `${toPersianNumber(formatNumbers(price))} تومان`}
                        )
                    </button>
                )}
                {!past && hasPaid && (
                    <button className="btn btn-outline-blue col-12" onClick={startHandler}>آغاز آزمون</button>
                )}
                {!past && !hasPaid && (
                    <button className="btn btn-outline-green col-12" onClick={onOpen}>
                        ثبت نام
                        (
                        {price===0? 'رایگان' : `${toPersianNumber(formatNumbers(price))} تومان`}
                        )
                    </button>
                )}
                <PayModal onClose={onClose} isOpen={isOpen} productId={id}/>
            </div>
        </div>
    </div>);
}

export default ExamCard;
